import * as React from "react";
import EnhancedTableHead from "../../../components/commonTable/index";
import CustomizedSwitches, { NewQueryBtn,ChatButton } from "../../../utils/helperdata";
import "./dashboard.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../../redux/slices/userSlice";
import HalfDonutChart from "./dashGraph";
import { fetchAllConversationTableAPI } from "../../../redux/action/UserAction";
import Cookies from "js-cookie";

function Dashboard() {
  // React Router and Redux setup
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get access token from cookies
  const reftokwn = Cookies.get("accessToken");

  // Extract conversation data from Redux store
  const { allConversationData } = useSelector(userSelector);

  // State to handle toggle switch
  const [isChecked, setIsChecked] = React.useState(false);

  // Dummy data for donut charts
  const chart1 = [
    { value: 30, category: "Active", color: "#1B2559" },
    { value: 50, category: "Inactive", color: "#F7F7FB" },
    { value: 20, category: "Offline", color: "#A4A8BD" },
  ];
  const chart2 = [
    { value: 30, category: "Active", color: "#7F56D9" },
    { value: 50, category: "Inactive", color: "#AB89F5" },
    { value: 10, category: "Offline", color: "#CDB7FF" },
    { value: 10, category: "Offline", color: "#CDB7FF" },
  ];

  // Fetch table data on component mount (currently commented)
  // React.useEffect(() => {
  //   dispatch(fetchAllConversationTableAPI());
  // }, []);

  return (
    <>
      {/* New Query Button Section */}
      <div className="newQuery-wrapper">
        <ChatButton navigate={navigate} />
        <NewQueryBtn navigate={navigate} />
      </div>

      {/* Dashboard Table and Charts Section */}
      <div className="dashboard-table-wrapper">
        {/* Toggle switch for filtering or mode */}
        <div>
          <CustomizedSwitches
            isChecked={isChecked}
            setIsChecked={setIsChecked}
          />
        </div>

        <div className="table-flex">
      {/* <-----------------Table displaying conversation records -------------------> */}
          <div className="table-container">
            <EnhancedTableHead
              tableData={allConversationData?.records ?? []}
              fullData={allConversationData}
            />
          </div>

          {/* Donut charts section */}
          <div className="chart-parent">
            <div className="chart">
              <p className="chart-title">My Queries</p>
              <HalfDonutChart chart1={chart1} />
            </div>
            <div className="chart">
              <p className="chart-title">Shared Queries</p>
              <HalfDonutChart chart1={chart2} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
